import {COLLECTION_USER} from '../users/constants';
import {COLLECTION_TRADING_TRADES} from './constants';

export function getTradeCollectionPath(uid: string): string {
  return `${COLLECTION_USER}/${uid}/${COLLECTION_TRADING_TRADES}`;
}
